import { render, staticRenderFns } from "./SalaryEmployee.vue?vue&type=template&id=70ffd40d"
import script from "./SalaryEmployee.vue?vue&type=script&lang=js"
export * from "./SalaryEmployee.vue?vue&type=script&lang=js"
import style0 from "./SalaryEmployee.vue?vue&type=style&index=0&id=70ffd40d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports